import { UserRoles } from '@/enums/UserRoles'

export default {
  computed: {
    isPedestrian() {
      return Boolean(
        this.visitor.transports && (
          this.visitor.transports.length < 1 ||
          this.visitor.transports[0].type === 'pedestrian'
        )
      )
    },

    visibleCloseButton() {
      return Boolean(this.user && [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(this.user.role))
    },

    visibleVisitorIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuVisitor.give_pass &&
        !this.cfgMenuVisitor.give_pass_period
      )
    },

    visibleVisitorIssuePassPeriodButton() {
      return this.visitor.access === 0 &&
          !this.cfgMenuVisitor.give_pass &&
          this.cfgMenuVisitor.give_pass_period
    },

    visibleVisitorPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuVisitor.give_pass &&
        !this.cfgMenuVisitor.give_pass_period &&
        this.visitor.personal.isIssued
      )
    },

    visibleVisitorPrintPassPeriodButton() {
      return this.visitor.access === 0 &&
          !this.cfgMenuVisitor.give_pass &&
          this.cfgMenuVisitor.give_pass_period &&
          this.visitor.personal.isIssued
    },

    visibleVisitorSendToSolvoButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuVisitor.send_to_solvo)
    },

    visibleVisitorSendToSkudButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuVisitor.send_to_skud &&
        // this.isPedestrian && // TODO not only pedestrians can be sent to scud
        !this.inScud
      )
    }
  }
}
